import { useLocation, Link } from 'react-router-dom'

export default function OrderSuccess() {
  const location = useLocation()
  const { orderNumber, customerName } = location.state || {}

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="max-w-md mx-auto px-4 text-center">
        {/* Success Icon */}
        <div className="w-24 h-24 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-yellow-500/30">
          <svg className="w-12 h-12 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Order <span className="text-yellow-500">Placed!</span>
        </h1>

        {orderNumber && (
          <div className="text-5xl font-bold text-white mb-6 text-shadow">
            #{orderNumber}
          </div>
        )}

        <p className="text-gray-300 text-lg mb-8">
          {customerName ? (
            <>
              Thanks, <span className="text-yellow-500 font-semibold">{customerName}</span>!
              We will call your name when your order is ready.
            </>
          ) : (
            <>Listen for your name - we will call you when it is ready!</>
          )}
        </p>

        <div className="bg-zinc-900 rounded-2xl p-6 border border-yellow-500/20 mb-8">
          <h3 className="text-lg font-semibold text-yellow-500 mb-3">What happens next?</h3>
          <div className="space-y-3 text-left">
            <div className="flex items-start gap-3">
              <span className="w-6 h-6 bg-yellow-500 text-black rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">1</span>
              <p className="text-gray-300 text-sm">Your order is being prepared fresh</p>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-6 h-6 bg-yellow-500 text-black rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">2</span>
              <p className="text-gray-300 text-sm">We will call your name when it is ready</p>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-6 h-6 bg-yellow-500 text-black rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">3</span>
              <p className="text-gray-300 text-sm">Pick up at the counter and enjoy!</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/order"
            className="px-8 py-4 bg-yellow-500 hover:bg-yellow-400 text-black font-bold rounded-xl transition-colors"
          >
            Order More
          </Link>
          <Link
            to="/"
            className="px-8 py-4 border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold rounded-xl transition-colors"
          >
            Back Home
          </Link>
        </div>
      </div>
    </div>
  )
}
